import React from "react";
import { default as WTable } from "@mui/material/Table";

function Table(props) {
  return <WTable {...props} />;
}

export default Table;
